import {ICONS} from '../../svgs'

import Styles from './PlayButton.module.css'

export interface PlayButtonProps {
  isPaused: boolean
  onToggle: (state: boolean) => void
  a11y: {
    label: string
  }
}

export const PlayButton = ({isPaused, onToggle, a11y}: PlayButtonProps) => {
  return (
    <button
      className={Styles['PlayButton']}
      aria-label={a11y.label}
      onClick={() => onToggle(!isPaused)}
      aria-pressed={isPaused}
    >
      {isPaused && ICONS.play}
      {!isPaused && ICONS.pause}
    </button>
  )
}
